(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cj-calculator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cj-medal-calculator')) {
  customElements.define('cj-medal-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.strings = JSON.parse(this.querySelector('[data-calc-strings]').textContent);
      this.fields = Object.fromEntries(Array.from(this.querySelectorAll('[data-choice]')).map(el => [el.dataset.choice, el]));
      this.side = 'front';
      this.failedRibbonPhotos = new Set();
      this.ribbonPhotos = Array.from(this.querySelectorAll('[data-ribbon-source]'));
      this.ribbonPhotos.forEach(photo => {
        photo.addEventListener('error', () => {
          this.failedRibbonPhotos.add(photo.dataset.ribbonSource);
          this.update();
        });
      });
      Array.from(this.fields.size.options).forEach(option => { option.textContent = Number(option.value).toLocaleString(this.dataset.locale === 'en' ? 'en-CA' : 'fr-CA', { minimumFractionDigits: 1 }) + ' ' + this.strings.unit_in; });
      this.numberFormat = new Intl.NumberFormat(this.dataset.locale === 'en' ? 'en-CA' : 'fr-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      this.addEventListener('input', () => this.update());
      this.addEventListener('change', () => this.update());
      this.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => {
        this.side = button.dataset.view;
        this.querySelectorAll('[data-view]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.update();
      }));
      this.querySelector('[data-quote]').addEventListener('click', event => {
        if (!this.validQuantity()) {
          event.preventDefault();
          this.fields.quantity.focus();
        }
      });
      this.update();
    }
    validQuantity() {
      const raw = this.fields.quantity.value.trim();
      const quantity = Number(raw);
      return /^\d+$/.test(raw) && Number.isSafeInteger(quantity) && quantity >= 10;
    }
    update() {
      const s = this.strings;
      const choice = Object.fromEntries(Object.entries(this.fields).map(([k, el]) => [k, el.value]));
      const quantity = Number(choice.quantity);
      const valid = this.validQuantity();
      const size = choice.size;
      const label = key => this.fields[key].selectedOptions[0].textContent;
      const ribbonColours = { black: '#232323', blue: '#175194', red: '#b72b32', ivory: '#e7e1ce', violet: '#6f468f', custom: '#6b6f76', none: '#ffffff' };
      const tariff = {
        BAL: { '2.75': 4.1273333333333335, '3.0': 4.632833333333334, '3.5': 5.191666666666666 },
        ACM: { '2.75': 4.3806722689075634, '3.0': 5.046842377260982, '3.5': 5.78522558922559 }
      };
      const reverse = { '2.75': 0.6666666666666666, '3.0': 0.75, '3.5': 0.8333333333333334 };
      let price = null;
      if (valid && choice.ribbon !== 'custom' && tariff[choice.material]?.[size] !== undefined) {
        const volumeAdjustment = quantity >= 1000 ? 0 : Math.max(0, 21.2 * (1 / quantity ** 0.6 - 1 / 1000 ** 0.6));
        price = Math.max(tariff[choice.material][size] + volumeAdjustment + (choice.printing === 'both' ? reverse[size] : 0), 75 / quantity);
        if (!Number.isFinite(price) || price <= 0) price = null;
      }
      this.querySelector('[data-price]').textContent = !valid ? '—' : price === null ? s.confirm : this.numberFormat.format(price);
      this.querySelector('[data-unit]').hidden = price === null;
      this.querySelector('[data-volume]').hidden = !(valid && quantity >= 2000);
      this.querySelector('[data-minimum]').hidden = price === null || Math.abs(price - 75 / quantity) > 0.000001;
      this.querySelector('[data-custom-condition]').hidden = choice.ribbon !== 'custom';
      this.fields.quantity.setAttribute('aria-invalid', String(!valid && choice.quantity !== ''));
      const error = this.querySelector('[data-error]');
      error.hidden = valid;
      error.dataset.empty = String(choice.quantity === '');
      error.textContent = choice.quantity === '' ? s.enter_quantity : s.invalid;
      const image = this.querySelector('[data-medal-image]');
      const url = choice.material === 'BAL' ? image.dataset.bal : image.dataset.acm;
      if (image.getAttribute('href') !== url) image.setAttribute('href', url);
      const scale = Number(size) / 3.5;
      const pixelsPerMillimetre = 382 / (3.5 * 25.4);
      const ribbonWidth = 35 * pixelsPerMillimetre;
      const ribbonBottom = 150;
      const radius = 191 * scale;
      const centreY = ribbonBottom + 185 * scale;
      const neckHalfWidth = 106;
      const shoulderX = neckHalfWidth + 18;
      const shoulderRise = Math.sqrt(radius * radius - shoulderX * shoulderX);
      const shoulderY = centreY - shoulderRise;
      const shoulderControlY = 158 + (shoulderY - 158) * .58;
      const tangentX = 250 + shoulderX - 20 * shoulderRise / radius;
      const tangentY = shoulderY - 20 * shoulderX / radius;
      const silhouette = `M156 103H344Q356 103 356 115V158C356 ${shoulderControlY} ${tangentX} ${tangentY} 374 ${shoulderY}A${radius} ${radius} 0 1 1 126 ${shoulderY}C${500 - tangentX} ${tangentY} 144 ${shoulderControlY} 144 158V115Q144 103 156 103Z M177 124H323Q331 124 331 132V142Q331 150 323 150H177Q169 150 169 142V132Q169 124 177 124Z`;
      this.querySelectorAll('[data-medal-shape]').forEach(path => path.setAttribute('d', silhouette));
      this.querySelector('[data-medal-edge]').setAttribute('fill', choice.material === 'BAL' ? '#9c7148' : '#555753');
      this.querySelector('[data-medal-outline]').setAttribute('stroke', choice.material === 'BAL' ? '#c29a70' : '#858780');
      const x = 250 - 250 * scale;
      const y = ribbonBottom - 82 * scale;
      this.querySelector('[data-artwork-transform]').setAttribute('transform', `translate(${x} ${y}) scale(${scale})`);
      this.querySelector('[data-demo-print]').style.display = this.side === 'front' || choice.printing === 'both' ? '' : 'none';
      this.querySelector('[data-artwork-front]').style.display = this.side === 'front' ? '' : 'none';
      this.querySelector('[data-artwork-back]').style.display = this.side === 'back' ? '' : 'none';
      this.querySelector('[data-artwork-caption]').textContent = this.side === 'front' ? s.art_reverse : choice.printing === 'both' ? s.art_phrase : s.art_blank;
      const ribbonVisual = this.querySelector('[data-ribbon-visual]');
      const ribbonScale = ribbonWidth / 116;
      ribbonVisual.setAttribute('transform', `translate(${250 - ribbonWidth / 2} ${ribbonBottom - 138 * ribbonScale}) scale(${ribbonScale})`);
      ribbonVisual.style.display = choice.ribbon === 'none' ? 'none' : '';
      this.querySelector('[data-ribbon-color]').setAttribute('fill', ribbonColours[choice.ribbon]);
      const ribbonPhoto = this.querySelector('[data-ribbon-photo]');
      const selectedRibbonPhoto = this.ribbonPhotos.find(photo => photo.dataset.ribbonSource === choice.ribbon);
      const showRibbonPhoto = Boolean(selectedRibbonPhoto) && !this.failedRibbonPhotos.has(choice.ribbon);
      this.ribbonPhotos.forEach(photo => { photo.style.display = photo === selectedRibbonPhoto ? '' : 'none'; });
      this.querySelector('[data-ribbon-seam-fallback]').style.display = showRibbonPhoto ? 'none' : '';
      ribbonPhoto.style.display = showRibbonPhoto ? '' : 'none';
      this.querySelector('[data-ribbon-placeholder]').style.display = showRibbonPhoto ? 'none' : '';
      const sizeLabel = Number(size).toLocaleString(this.dataset.locale === 'en' ? 'en-CA' : 'fr-CA', { minimumFractionDigits: 1 }) + ' ' + s.unit_in;
      this.querySelector('[data-size-label]').textContent = sizeLabel;
      const selection = [label('material'), sizeLabel, label('printing'), label('ribbon')].join(' · ');
      this.querySelector('[data-selection]').textContent = selection;
      this.querySelector('.cj-calc-stage').setAttribute('aria-label', [s.preview, selection, this.side === 'front' ? s.front : s.rear].join('. '));
      this.querySelector('[data-rear-note]').hidden = this.side !== 'back' || choice.printing !== 'front';
      const ribbonNote = this.querySelector('[data-ribbon-note]');
      ribbonNote.hidden = choice.ribbon === 'none';
      ribbonNote.textContent = choice.ribbon === 'custom' ? s.custom_ribbon_note : s.ribbon_note;
      const contact = new URL(this.dataset.contact, document.baseURI);
      contact.searchParams.set('cj_from', 'calculator');
      if (valid) contact.searchParams.set('cj_qty', String(quantity));
      ['material', 'size', 'printing', 'ribbon'].forEach(k => contact.searchParams.set('cj_' + k, choice[k]));
      if (price !== null) contact.searchParams.set('cj_estimate', price.toFixed(2));
      contact.hash = 'cj-soumission';
      this.querySelector('[data-quote]').href = contact.pathname + contact.search + contact.hash;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cj-quote-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('cj_from') !== 'calculator') return;
  const stringsNode = document.getElementById('cj-prefill-strings');
  const summary = document.querySelector('[data-cj-estimate-summary]');
  if (!stringsNode || !summary) return;
  const s = JSON.parse(stringsNode.textContent);
  const locale = document.documentElement.lang.startsWith('en') ? 'en-CA' : 'fr-CA';
  const number = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const quantity = params.get('cj_qty') || '';
  const material = params.get('cj_material');
  const size = params.get('cj_size');
  const printing = params.get('cj_printing');
  const ribbon = params.get('cj_ribbon');
  if (!/^\d+$/.test(quantity) || !Number.isSafeInteger(Number(quantity)) || Number(quantity) < 1) return;
  if (!['ACM','BAL'].includes(material) || !['2.75','3.0','3.5'].includes(size) || !['front','both'].includes(printing) || !['black','blue','red','ivory','violet','none','custom'].includes(ribbon)) return;
  const lines = [
    s.quantity + ' : ' + quantity,
    s.material + ' : ' + s[material.toLowerCase()],
    s.size + ' : ' + Number(size).toLocaleString(locale, { minimumFractionDigits: 1 }) + ' ' + s.unit_in,
    s.printing + ' : ' + s[printing === 'both' ? 'both' : 'front_only'],
    s.ribbon + ' : ' + s[ribbon]
  ];
  const estimate = params.get('cj_estimate');
  if (estimate && /^\d{1,8}\.\d{2}$/.test(estimate) && Number(estimate) > 0) lines.push(s.reference + ' : ' + number.format(Number(estimate)) + ' ' + s.per_unit);
  if (ribbon === 'custom') lines.push(s.custom_condition);
  const quantityField = document.querySelector('input[name="contact[quantity]"]');
  if (quantityField && !quantityField.value) quantityField.value = quantity;
  summary.querySelector('[data-cj-estimate-text]').value = lines.join('\n');
  summary.hidden = false;
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener('product-form:cart:navigate', (event) => {
    if (window.CART_ACTION === 'ajax' || window.CART_ACTION === 'reload_page' || window.CART_ACTION === 'redirect_checkout') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_ACTION === 'ajax') {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: function(cart) {
          refreshCartComplete(cart);
          
          setTimeout(function() { 
            $('.cart-button').click(); 
          }, 100);
        }
      });
    } else if (window.CART_ACTION === 'reload_page') {
      window.location.reload();
    } else if (window.CART_ACTION === 'redirect_cart') {
      window.location.href = '/cart';
    } else if (window.CART_ACTION === 'redirect_checkout') {
      window.location.href = window.CHECKOUT_URL;
    }
  });

  // Copied from app.js
  function refreshCartComplete(cart) {
    const $cartBtn = $(".cart-button span");
    if ($cartBtn && $cartBtn.length) {
      var value = $cartBtn.text() || '0';
      var cart_items_html = "";
      var $cart = $("#cart ul");

      $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
      $cart.find('li:not(:first)').remove();

      if (cart.item_count == 0) {
        $cart.append('<li class="empty_cart">' + window.PXUTheme.translation.empty_cart + '</li>');
      } else {
        $.each(cart.items, function(index, item) {
          var line_id = index + 1;
          let discountMessage = '';
          let unitPricingOutput = '';

          if (item.unit_price_measurement) {
            unitPricingOutput = window.product.unitPricing(item);
          }

          // Discounts logic
          if (item.discounts.length) {
            var discountAmount = Shopify.formatMoney(item.discounts[0].amount, $('body').data('money-format'));
            var title = item.discounts[0].title;
            discountMessage = `
              <span class="notification-discount">
                ${window.PXUTheme.translation.cart_discount}: ${title} (-<span class="money">${discountAmount}</span>)
              </span>
            `;
          }

          cart_items_html += `
            <li class="mm-listitem">
              <a class="cart__item" href="${item.url}">
          `;

          if (item.image) {
            cart_items_html += `
              <div class="cart__image">
                <img src="${item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '')}" alt="${htmlEncode(item.title)}"/>
              </div>
            `;
          }

          cart_items_html += `
            <div class="cart__info">
              <div class="cart__description">
              ${item.title}
          `;

          if(item.properties) {
            $.each(item.properties, function(title, value) {
              if (value && value !== 'on') {
                cart_items_html += `
                  <div class="line-item">
                    ${title}: ${value}
                  </div>
                `;
              }
            });
          }

          if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
            cart_items_html += `
              <br>
              <span class="line-item selling-plan">
                ${item.selling_plan_allocation.selling_plan.name}
              </span>
            `;
          }

          if (item.price > item.final_price) {
            cart_items_html += `
              <div class="cart__price">
                <span class="money">
                  ${Shopify.formatMoney(item.final_line_price, $('body').data('money-format'))}
                </span>
                <span class="was_price money">
                  ${Shopify.formatMoney(item.original_line_price, $('body').data('money-format'))}
                </span>
              </div>
              <div class="cart__unit-price">
                ${unitPricingOutput}
              </div>
              <div class="cart__discount">
                ${discountMessage}
              </div>
              </div>
            `;
          } else {
            cart_items_html += `
              <div class="cart__price">
                <span class="money">
                  ${Shopify.formatMoney(item.price, $('body').data('money-format'))}
                </span>
              </div>
              <div class="cart__unit-price">
                ${unitPricingOutput}
              </div>
              </div>
            `;
          }

          cart_items_html += `
            <div class="cart__quantity">
              <span class="icon-minus minus"></span>
              <input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-line-id="${line_id}" />
              <span class="icon-plus plus"></span>
            </div>
            </div>
            </div>
            </a>
          `;
        });

        var cartDiscounts = cart.cart_level_discount_applications;
        var cartDiscountMessage = "";

        for (let i=0; i < cartDiscounts.length; i++) {
          var amount = Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
          var title = cartDiscounts[i].title;
          cartDiscountMessage = '<p class="mm-counter price mm-discount-label mm-listitem__text">' + title + '<span>' + '(- <span class="money">' + amount + '</span>)' + '</span>' + '</p>';
        }

        if (cart.cart_level_discount_applications.length > 0) {
          cart_items_html += '<li class="mm-label mm-listitem">' + cartDiscountMessage + '</li>'
        }

        cart_items_html += `
          <li class="mm-label mm-listitem">
            <a href="/cart" class="cart__item-subtotal">
              <span>
                ${window.PXUTheme.translation.subtotal}
              </span>
              <span class="mm-counter price">
                <span class="money">
                  ${Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}
                </span>
              </span>
            </a>
          </li>
          <li class="mm-subtitle mm-listitem">
        `;

        if (window.PXUTheme.theme_settings.display_special_instructions) {
          var cart_note = cart.note ? cart.note : '';
          cart_items_html += '<textarea id="cart-note" name="note" rows="2" placeholder="' + window.PXUTheme.translation.cart_notes + '" class="clearfix">' + cart_note + '</textarea>';
        };

        if (window.PXUTheme.theme_settings.display_tos_checkbox) {
          cart_items_html += '<aside class="tos tos_checkbox"><input type="checkbox" class="tos_agree" id="sliding_agree" required /><label class="tos_label" for="sliding_agree"> ' +
          window.PXUTheme.theme_settings.tos_richtext  + '</label></aside>';
        };

        cart_items_html += '<span class="mm-action_buttons mm-listitem__text">';
        if (window.DISPLAY_VIEW_CART) {
          cart_items_html += '<a href="' + window.PXUTheme.theme_settings.cart_url + '" class="action_button edit_cart left">' + window.PXUTheme.translation.edit_cart + '</a>';
        }
        cart_items_html += '<input type="submit" class="action_button ' + (window.DISPLAY_VIEW_CART ? 'right' : 'full-width') + '" value="' + window.PXUTheme.translation.checkout + '"/>';
        cart_items_html += '</span></li>';

        $cart.append(cart_items_html);
        $cart.find('li.cart_item:last').addClass('last_cart_item');
      }
    }
  }

  function htmlEncode(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
  }


  } catch(e) { console.error(e); }
})();
})();
